import { render, staticRenderFns } from "./transmissionProposalLoading.vue?vue&type=template&id=6cc0c8dc&scoped=true"
import script from "./transmissionProposalLoading.vue?vue&type=script&lang=js"
export * from "./transmissionProposalLoading.vue?vue&type=script&lang=js"
import style0 from "./transmissionProposalLoading.vue?vue&type=style&index=0&id=6cc0c8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc0c8dc",
  null
  
)

export default component.exports